import moment from 'moment-timezone';
import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Progress } from 'react-sweet-progress';

import { css, classNamesFunction, IconButton, IButtonProps, IStyle, Panel, PanelType, ThemeSettingName } from 'office-ui-fabric-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

import { EgActionEntity, EgTestEntity, WsActionType } from '../../../data';
import { Loading } from '../';

import './ActionHistory.scss';

type ActionHistoryState = {
  showScreenshotUrl: string;
  showTestId: number;
  showTestProcess: EgTestEntity | undefined;
  testLog: string | undefined;
}

class ActionHistory extends React.Component<any, ActionHistoryState> {

  constructor(props: any) {
    super(props);

    this.state = {
      showScreenshotUrl: '',
      showTestId: 0,
      showTestProcess: undefined,
      testLog: undefined
    };
  }

  // details

  ActionDetails = (props: { action: EgActionEntity, test: EgTestEntity }) => {
    const listItems = props.test.steps.map((step: any) => {
      return (
        <tr key={step.id.toString()}>
          <td>
            { step.id >   props.test.currentStep && <Icon className="eg-instruction-pending" iconName={'StatusCircleRing'} /> }
            { step.id === props.test.currentStep && <Icon className="eg-instruction-running" iconName={'Running'} /> }
            { step.id <   props.test.currentStep && <Icon className="eg-instruction-completed" iconName={'SkypeCircleCheck'} /> }
          </td>
          <td>{step.name}</td>
        </tr>
      );
    });

    return(
      <div className="eg-details">
        <div className="eg-path"></div>
        <div className="eg-triangle"></div>
        <div className="eg-details-content">
          <b>Progress</b>
          <table className="table is-fullwidth">
            <tbody>
              {listItems}
            </tbody>
          </table>
          <button className="button is-small" onClick={(e) => this.showPanel(e, props.test)}>Test Details</button>
        </div>
      </div>
    );
  }

  // dropdown

  ActionMenu = (props: { action: EgActionEntity }) => {

    if (props.action.type === WsActionType.Defer) {
      // defer
      return (<Fragment><b>Defer</b> ({moment(props.action.createdAt).fromNow()})</Fragment>);

    } else if (props.action.type === WsActionType.Upgrade) {
      // upgrade
      return (<Fragment><b>Upgrade</b> ({moment(props.action.createdAt).fromNow()})</Fragment>);

    } else if (props.action.type === WsActionType.Replace) {
      // replace
      return (<Fragment><b>Replace</b> ({moment(props.action.createdAt).fromNow()})</Fragment>);

    } else if (props.action.type === WsActionType.Remove) {
      // remove
      return (<Fragment><b>Remove</b> ({moment(props.action.createdAt).fromNow()})</Fragment>);

    } else {
      // test

      if (props.action.test && props.action.test.approved) {
        return (
          <Fragment>
            <div>
              <b>Test</b> ({moment(props.action.createdAt).fromNow()})
            </div>
            <div className="eg-action-details">
              <this.ActionDetails action={props.action} test={props.action.test} />
              <IconButton iconProps={{ iconName: 'MultiSelect' }} title="Details" />
              <div className="eg-progress">
                <Progress percent={props.action.test.progress} status={props.action.status()} />
              </div>
            </div>
            <div>
              <b>{props.action.test && props.action.test.testScenario ? props.action.test.testScenario.name : '-'}</b><br />
              Elapsed: {props.action.duration()}
            </div>
          </Fragment>
        );
      } else if (props.action.test && props.action.test.declined) {
        return (
          <Fragment><b>Testing Declined</b> ({moment(props.action.createdAt).fromNow()})</Fragment>
        );
      } else {
        return (
          <b>Awaiting Approval</b>
        );
      }
    }
  }

  // render

  render() {
    if (this.props.actions) {
      const listItems = this.props.actions.map((action: EgActionEntity) => {

        if (action.application) {
          return (
            <tr key={action.id && action.id.toString()}>
              { this.props.showApplication &&
                <td>
                  <NavLink to={`/servicing/windows/${this.props.servicingVersionNumber}/prepare/applications/${action.application.id}`}>{action.application.publisher.name} {action.application.name}</NavLink>
                </td>
              }
              <td>{action.applicationVersion ? action.applicationVersion.number : '-'}</td>
              <td>{action.operatingSystemVersion ? action.operatingSystemVersion.number : '-'}</td>
              <td>{action.ownerName}</td>
              <td className="eg-test-column">
                <this.ActionMenu action={action} />
              </td>
            </tr>
          );
        } else {
          return null;
        }
      });

      return (
        <div className={[ 'eg-application-status', 'eg-application-table' ].join(' ')}>
          <Fragment>
            { this.props.actions.length > 0 &&
              <table className="table is-hoverable is-fullwidth">
                <thead>
                  <tr>
                    { this.props.showApplication &&
                      <th>Application</th>
                    }
                    <th>Version</th>
                    <th>OS Version</th>
                    <th>Initiator</th>
                    <th className="eg-test-column">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {listItems}
                </tbody>
              </table>
            }

            { this.props.actions.length < 1 && <div className="notification is-warning">No actions here yet!</div> }
          </Fragment>

          <this.DetailsPanel />
        </div>
      );

    } else {
      return (<Loading />);
    }
  }

  // panel

  setTestLog = (log: string) => {
    // if () {
      this.setState({
        testLog: log ? log : '-'
      });

  }

  DetailsPanel: React.FC<any> = (props: any) => {

    if (this.props.actions && this.state.showTestId) {
      const action: EgActionEntity | undefined = this.props.actions.find((action: EgActionEntity) => action.test && action.test.id == this.state.showTestId);

      if (action && action.test) {

        const listItems = action.test.operations.sort((a: any, b: any) => a.position > b.position ? 1 : -1).map((operation: any) => {
          return (
            <tr key={operation.id.toString()} onClick={(e) => this.setTestLog(operation.log)}>
              <td>
                { operation.status === -1 && <Icon className="eg-instruction-failed" iconName={'StatusErrorFull'} /> }
                { operation.status ===  0 && <Icon className="eg-instruction-pending" iconName={'StatusCircleRing'} /> }
                { operation.status ===  1 && <Icon className="eg-instruction-running" iconName={'Running'} /> }
                { operation.status ===  2 && <Icon className="eg-instruction-completed" iconName={'SkypeCircleCheck'} /> }
              </td>
              <td>{ operation.instruction ? operation.instruction.name : '-'}</td>
            </tr>
          );
        });

        const screenshot = `${process.env.REACT_APP_WSP_API_BASE_URL}/test-processes/${action.test.id}/screenshot-0001.png`;

        return (
          <div className="eg-test-details">
            <Panel
              customWidth="700px"
              isBlocking={false}
              isOpen={ this.state.showTestId > 0 ? true : false}
              onDismiss={this.hidePanel}
              type={PanelType.custom}
              headerText={action.test && action.test.testScenario ? action.test.testScenario.name : '-'}
              className="eg-test-details-panel"
            >

              <div className="eg-operation-list">
                <h3 className="title is-6">Operations</h3>
                { this.state.showTestId > 0 &&
                  <Fragment>
                    <div className="eg-details">
                      <div className="eg-path"></div>
                      <div className="eg-triangle"></div>
                      <div className="eg-details-content">
                        <table className="table is-fullwidth">
                          <tbody>
                            { action.test.virtualMachine &&
                              <tr key={0}>
                                <td>
                                  <Icon className="eg-instruction-completed" iconName={'SkypeCircleCheck'} />
                                </td>
                                <td>Create VM ({action.test.virtualMachine.name})</td>
                              </tr>
                            }
                            {listItems}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Fragment>
                }
              </div>

              { this.state.showTestProcess && this.state.showTestProcess.screenshotCount > 0 &&
                <div className="eg-test-screenshots">
                  <h3 className="title is-6">Screenshots</h3>
                  <a onClick={(e) => this.showScreenshot(e, screenshot)}><img src={screenshot} alt="screenshot" /></a>
                </div>
              }

              { !this.state.testLog && <div className="eg-test-log-empty"><Icon iconName={'Source'} className="eg-source-icon" /><br/>Please select operation to view output.</div> }
              { this.state.testLog &&
                <div className="eg-test-log">
                  <h3 className="title is-6">Log</h3>
                  <textarea className="textarea" readOnly={true} value={this.state.testLog} placeholder="Output from Test Script"></textarea>
                </div>
              }

            </Panel>
            <div className={ 'modal' + (this.state.showScreenshotUrl.length > 0 ? ' is-active' : '')}>
              <div className="modal-background" onClick={(e) => this.hideScreenshot(e)}></div>
              <div className="modal-content">
                <p className="image">
                  <img src={this.state.showScreenshotUrl} alt="" />
                </p>
              </div>
              <button className="modal-close is-large" aria-label="close" onClick={(e) => this.hideScreenshot(e)}></button>
            </div>
          </div>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  showScreenshot = (event: any, url: string) => {
    this.setState({
      showScreenshotUrl: url
    });
  }

  hideScreenshot = (event: any) => {
    this.setState({
      showScreenshotUrl: ''
    });
  }

  showPanel = async (event: any, test: any) => {
    this.setState({
      showTestId: test ? test.id : 0
    });

    const t = await  EgTestEntity.fingById(test.id);

    this.setState({
      showTestProcess: t
    });
  }

  hidePanel = (event: any) => {
    this.setState({
      showTestId: 0,
      showTestProcess: undefined,
      testLog: undefined
    });
  }
}

export {
  ActionHistory
};
